import { useFormContext } from 'react-hook-form'
import { useFormDisable } from './form'
import { FormNewLabel } from './form-label'
import { useEffect } from 'react'

export const FormNewTextConfirm = ({ name, label, confirmValue, disabled, autoFocus }) => {
  const { register, watch, setError, clearErrors } = useFormContext()

  const formDisabled = useFormDisable()

  let value = watch(name)

  useEffect(
    () => {
      if (value && confirmValue) {
        if (value.trim().toLowerCase() !== confirmValue.trim().toLowerCase()) setError(name, { message: 'mismatch' })
        else clearErrors(name)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, confirmValue]
  )

  return (
    <FormNewLabel name={name} label={label} subtext={`Type ${confirmValue} to confirm`} required hideLabel>
      <input
        className="form-control"
        type="text"
        {...register(name, { required: true, disabled: formDisabled || disabled })}
        placeholder={confirmValue}
        autoFocus={autoFocus}
      />
    </FormNewLabel>
  )
}
